import { render, staticRenderFns } from "./WallGiftRegistryBlockSettings.vue?vue&type=template&id=045bba5d"
import script from "./WallGiftRegistryBlockSettings.vue?vue&type=script&lang=js"
export * from "./WallGiftRegistryBlockSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports